import { useState, useMemo } from 'react';

export interface Platform {
  id: string;
  name: string;
  type: string;
  basePrice: number;
  enabled: boolean;
  profiles: number;
}

const INITIAL_PLATFORMS: Platform[] = [
  { id: '1', name: 'Агентка (РЕГБИЗ)', type: 'simple', basePrice: 15, enabled: false, profiles: 1 },
  { id: '5', name: 'Агентка (РКО)', type: 'simple', basePrice: 5, enabled: false, profiles: 1 },
  { id: '2', name: 'FCN', type: 'fincp', basePrice: 17, enabled: false, profiles: 1 },
  { id: '6', name: 'FCN (РКО)', type: 'fincp_rko', basePrice: 5, enabled: false, profiles: 1 },
  { id: '3', name: 'Пампаду', type: 'pampadu', basePrice: 17, enabled: false, profiles: 1 },
  { id: '7', name: 'Пампаду (РКО)', type: 'pampadu_rko', basePrice: 5, enabled: false, profiles: 1 },
  { id: '4', name: 'РКО Групп', type: 'rko_group', basePrice: 20, enabled: false, profiles: 1 },
  { id: '8', name: 'РКО Групп (РКО)', type: 'rko_group_rko', basePrice: 5, enabled: false, profiles: 1 },
  { id: '9', name: 'Ссылка на собственный сайт', type: 'own_site', basePrice: 5, enabled: false, profiles: 1 },
];

const BUNDLE_DISCOUNTS: Record<number, number> = {
  1: 0,
  2: 0.10,
  3: 0.15,
  4: 0.20,
};

function calcPlatformCost(basePrice: number, profiles: number): number {
  return basePrice + (profiles - 1) * basePrice * 0.70;
}

function calcWorkerCost(workers: number): number {
  let total = 0;
  for (let i = 1; i <= workers; i++) {
    if (i <= 4) total += 2.0;
    else if (i <= 10) total += 1.5;
    else total += 1.0;
  }
  return total;
}

export function useCalculator() {
  const [platforms, setPlatforms] = useState<Platform[]>(INITIAL_PLATFORMS);
  const [workers, setWorkers] = useState<number>(0);
  const [workerDays, setWorkerDays] = useState<number>(30);

  const togglePlatform = (id: string) => {
    setPlatforms(prev =>
      prev.map(p => (p.id === id ? { ...p, enabled: !p.enabled } : p))
    );
  };

  const setProfiles = (id: string, value: number) => {
    setPlatforms(prev =>
      prev.map(p => (p.id === id ? { ...p, profiles: Math.min(10, Math.max(1, value)) } : p))
    );
  };

  const result = useMemo(() => {
    const enabledPlatforms = platforms.filter(p => p.enabled);
    const enabledCount = enabledPlatforms.length;

    const platformsRawTotal = enabledPlatforms.reduce(
      (sum, p) => sum + calcPlatformCost(p.basePrice, p.profiles),
      0
    );

    const discountRate = BUNDLE_DISCOUNTS[Math.min(enabledCount, 4)] ?? 0;
    const discountAmount = platformsRawTotal * discountRate;
    const platformsTotal = platformsRawTotal - discountAmount;

    const workerFullMonthTotal = calcWorkerCost(workers);
    const workerTotal = workerFullMonthTotal * (workerDays / 30);
    const total = platformsTotal + workerTotal;

    return {
      platformsRawTotal,
      discountRate,
      discountAmount,
      platformsTotal,
      workerTotal,
      workerFullMonthTotal,
      total,
      enabledCount,
    };
  }, [platforms, workers, workerDays]);

  return {
    platforms,
    workers,
    workerDays,
    togglePlatform,
    setProfiles,
    setWorkers,
    setWorkerDays,
    result,
  };
}
